import { render } from "./AdminCard.vue?vue&type=template&id=af89e996&scoped=true"
import script from "./AdminCard.vue?vue&type=script&lang=js"
export * from "./AdminCard.vue?vue&type=script&lang=js"

import "./AdminCard.vue?vue&type=style&index=0&id=af89e996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af89e996"]])

export default __exports__